var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"image-loader md-card"},[_c('md-button',{ref:"loadImagesButton",staticClass:"md-raised md-primary",on:{"click":_vm.onButtonClick}},[_vm._v("Load Images")]),_c('input',{ref:"fileInput",staticStyle:{"display":"none"},attrs:{"type":"file","accept":"image/*","multiple":""},on:{"change":_vm.onFileChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }